import { watchGetIdentity } from "./getIdentity";
import { watchEndCall } from "./endCall";
import { availAccessTokenTimer } from "./refreshAccessToken";

export default [watchGetIdentity(), watchEndCall(), availAccessTokenTimer()];
